import React, { useState } from 'react';
import { Plus, Trash2, ChevronLeft, ChevronRight } from 'lucide-react';
import { FieldError, cls, getErr } from './helpers';
import { toast } from 'react-toastify';

const EMPTY = { langue: '', parler_niveau: '1', ecrire_niveau: '1', lire_niveau: '1' };
const NIVEAUX = [
    { value: '1', label: 'Débutant' },
    { value: '2', label: 'Intermédiaire' },
    { value: '3', label: 'Avancé' },
];

const StepLangues = ({ langues, onLanguesChange, listeLangues, onNext, onBack }) => {
    const [form, setForm]     = useState(EMPTY);
    const [errors, setErrors] = useState({});

    const validate = () => {
        const e = {};
        if (!form.langue) e.langue = "La langue est requise";
        setErrors(e);
        return Object.keys(e).length === 0;
    };

    const addLangue = () => {
        if (!validate()) return;
        const nomLangue = listeLangues.find(l => String(l.id) === String(form.langue))?.langue || form.langue;
        onLanguesChange([...langues, { ...form, _nom: nomLangue }]);
        setForm(EMPTY);
        setErrors({});
    };

    const getNiveauLabel = (val) => NIVEAUX.find(n => n.value === String(val))?.label || val;

    const niveauOptions = NIVEAUX.map(n => <option key={n.value} value={n.value}>{n.label}</option>);

    const handleNext = () => {
        if (langues.length === 0) { toast.error("Ajoutez au moins une langue"); return; }
        onNext();
    };

    return (
        <div className="space-y-4">
            <div className="border border-gray-200 rounded-lg p-4 space-y-3">
                <h4 className="text-sm font-semibold text-orange-700 flex items-center gap-1"><Plus className="h-4 w-4" /> Ajouter une langue</h4>
                <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">Langue <span className="text-red-500">*</span></label>
                    <select value={form.langue} onChange={e => setForm(p => ({...p, langue: e.target.value}))} className={cls(errors.langue, false)}>
                        <option value="">Sélectionnez une langue</option>
                        {listeLangues.map(l => <option key={l.id} value={l.id}>{l.langue}</option>)}
                    </select>
                    <FieldError msg={getErr(errors, 'langue')} />
                </div>
                <div className="grid grid-cols-3 gap-2">
                    {[['parler_niveau', 'Parler'], ['ecrire_niveau', 'Écrire'], ['lire_niveau', 'Lire']].map(([field, label]) => (
                        <div key={field}>
                            <label className="block text-xs font-medium text-gray-700 mb-1">{label}</label>
                            <select value={form[field]} onChange={e => setForm(p => ({...p, [field]: e.target.value}))} className={cls(false, false)}>
                                {niveauOptions}
                            </select>
                        </div>
                    ))}
                </div>
                <button type="button" onClick={addLangue} className="w-full py-2 bg-orange-600 hover:bg-orange-700 text-white rounded-lg text-sm font-medium flex items-center justify-center gap-1 transition">
                    <Plus className="h-4 w-4" /> Ajouter cette langue
                </button>
            </div>

            {langues.length > 0 && (
                <div className="space-y-2">
                    <p className="text-xs font-medium text-gray-600">Langues ajoutées ({langues.length})</p>
                    {langues.map((l, i) => (
                        <div key={i} className="flex items-center justify-between bg-green-50 border border-green-200 rounded-lg px-3 py-2">
                            <div>
                                <p className="text-sm font-medium text-gray-800">{l._nom}</p>
                                <p className="text-xs text-gray-500">
                                    Parler : {getNiveauLabel(l.parler_niveau)} · Écrire : {getNiveauLabel(l.ecrire_niveau)} · Lire : {getNiveauLabel(l.lire_niveau)}
                                </p>
                            </div>
                            <button onClick={() => onLanguesChange(langues.filter((_, idx) => idx !== i))} className="text-red-400 hover:text-red-600"><Trash2 className="h-4 w-4" /></button>
                        </div>
                    ))}
                </div>
            )}

            <div className="flex gap-2 pt-1">
                <button onClick={onBack} className="flex items-center gap-1 px-4 py-2.5 border border-gray-300 text-gray-600 rounded-lg text-sm hover:bg-gray-50 transition"><ChevronLeft className="h-4 w-4" /> Retour</button>
                <button onClick={handleNext} disabled={langues.length === 0} className="flex-1 flex justify-center items-center gap-2 py-2.5 bg-orange-600 hover:bg-orange-700 disabled:bg-orange-300 text-white rounded-lg text-sm font-medium transition">
                    Continuer ({langues.length} langue{langues.length > 1 ? 's' : ''}) <ChevronRight className="h-4 w-4" />
                </button>
            </div>
        </div>
    );
};

export default StepLangues;
